module.exports = __webpack_public_path__ + "img/audit.dcce8e3a.jpg";